import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConneqtStatus } from '../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { Chips } from '../../components/chips/chips';

interface StatusProps {
  status: ConneqtStatus;
  testId?: string;
}

export const BadgeStatus = ({ status, testId }: StatusProps) => {
  const { t } = useTranslation();
  return (
    <>
      {status === ConneqtStatus.Created && (
        <Chips
          testId={testId}
          label={t('CONNEQT_CREATED')}
          variant="filled"
          color="primary"
          size="small"
          sx={{ fontSize: '11px' }}
        />
      )}

      {status === ConneqtStatus.AccountNotFound && (
        <Chips
          testId={testId}
          label={t('CONNEQT_ACCOUNT_NOT_FOUND')}
          color="warning"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}

      {status === ConneqtStatus.SentInvite && (
        <Chips
          testId={testId}
          label={t('SEND_INVITE')}
          color="warning"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}

      {status === ConneqtStatus.SentInviteFailed && (
        <Chips
          testId={testId}
          label={t('CONNEQT_SEND_INVITE_FAILED')}
          color="error"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}

      {status === ConneqtStatus.INVITE_SENT && (
        <Chips
          testId={testId}
          label={t('CONNEQT_INVITE_SENT')}
          color="info"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
      {status === ConneqtStatus.Pending && (
        <Chips
          testId={testId}
          label={t('CONNEQT_PENDING')}
          color="warning"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
      {status === ConneqtStatus.Disconneqted && (
        <Chips
          testId={testId}
          label={t('CONNEQT_DISCONNEQTED')}
          color="info"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
      {status === ConneqtStatus.Conneqted && (
        <Chips
          testId={testId}
          label={t('CONNEQT_CONNEQTED')}
          color="success"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
      {status === ConneqtStatus.REJECTED && (
        <Chips
          testId={testId}
          label={t('CONNEQT_REJECTED')}
          color="error"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
      {status === ConneqtStatus.ClinicAppointmentBooked && (
        <Chips
          testId={testId}
          label={t('CLINIC_APPOINTMENT_BOOKED')}
          color="success"
          size="small"
          variant="filled"
          sx={{ fontSize: '11px' }}
        />
      )}
    </>
  );
};
